import { css } from '@emotion/css';

import {
  mobileMediaQuery,
  nonMobileMediaQuery,
  nonTwoColumnCollapseMediaQuery,
} from '../../../constants';
import { m } from '../../../motif/m';

export const footerHeaderCss = css`
  font-weight: ${m('--footer-bar-header-font-weight')};
  text-transform: ${m('--footer-bar-header-mobile-font-text-transform')};
  padding-inline-end: ${m('--spacing-xl')};
  word-break: break-word;

  ${nonMobileMediaQuery} {
    padding-inline-end: 0;
    text-transform: ${m('--footer-bar-header-desktop-font-text-transform')};
  }
`;

export const footerHeaderSpacingCss = css`
  ${nonMobileMediaQuery} {
    margin-block-end: ${m('--spacing-xs')};
  }
`;

export const footerGroupCss = css`
  border-bottom: 1px solid ${m('--footer-border-color')};
  font-size: ${m('--footer-desktop-font-size')};
  line-height: 16px;
  padding-block: ${m('--spacing-m')};
  padding-inline: 0 ${m('--spacing-m')};
  color: ${m('--fg-color')};

  &:first-child {
    padding-block-start: ${m('--spacing-s')};
  }

  &:last-child {
    border-bottom: 0;
  }

  ${nonMobileMediaQuery} {
    border-bottom: 0;
    padding-bottom: ${m('--spacing-xxs')};
    padding-inline: 0;
    padding-top: 0;

    &:first-child {
      padding-block-start: 0;
    }
  }

  ${mobileMediaQuery} {
    font-size: ${m('--footer-mobile-font-size')};
    font-weight: ${m('--action-mobile-font-weight')};
  }
`;

export const footerColumnListCss = css`
  display: flex;
  flex-direction: column;
  list-style-type: none;
  margin: 0;
  padding-block: ${m('--spacing-s')} 0;
  padding-inline: 0;
  width: 100%;

  ${nonMobileMediaQuery} {
    padding: 0;
  }
`;

export const footerHorizontalLayoutCss = css`
  a {
    margin-inline: 0;
    white-space: unset;
  }

  li {
    margin: 0;
  }

  align-items: flex-start;
  border: 0;
  display: flex;
  flex-direction: column;
  gap: ${m('--spacing-m')};
  padding-block: ${m('--spacing-s')};

  ${nonMobileMediaQuery} {
    align-items: center;
    flex-direction: row;
    gap: ${m('--spacing-l')};
    padding-block: 0;

    &:first-child {
      padding-block-start: 0;
    }
  }

  ${nonTwoColumnCollapseMediaQuery} {
    &:first-child {
      margin-inline-start: 0;
    }

    &:last-child {
      margin-inline-end: 0;
    }
  }
`;
